import React, { useState, useEffect, useRef } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Badge from '@material-ui/core/Badge';
import Header from "components/Header/Header.js";
import LeaderBoard from "components/EventLeaderBoard/LeaderBoard.js";
import SendAnswer from "components/ICTChallengeSendAnswer/index.js";
import Divider from '@material-ui/core/Divider';
import Chip from '@material-ui/core/Chip';
import ReactHtmlParser from 'react-html-parser';
import HourglassEmptyOutlinedIcon from '@material-ui/icons/HourglassEmptyOutlined';
import ScoreOutlinedIcon from '@material-ui/icons/ScoreOutlined';
import FiberNewIcon from '@material-ui/icons/FiberNew';
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import NavigateBeforeOutlinedIcon from '@material-ui/icons/NavigateBeforeOutlined';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import RefreshRoundedIcon from '@material-ui/icons/RefreshRounded';
import Parallax from "components/Parallax/Parallax.js";
import Axios from "axios";
import Config from "../../../config.js"
import swal from 'sweetalert'
import styles from "assets/jss/material-kit-react/views/ictchallengesEvent.js";
import { CloudDownloadOutlined } from "@material-ui/icons";
import Ads from "../../Main/Sections/Ads3.js";




const useStyles = makeStyles(styles);

export default function ICTChallengesMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    const [refreshLeaderBoard, setRefreshLeaderBoard] = React.useState(false);
    const [diff, setDiff] = React.useState(0);
    useInterval(() => {
        var d = diff + 1;
        setDiff(d)
        if (d > 300) {
            setRefreshLeaderBoard(!refreshLeaderBoard);
            setDiff(0);
        }
    }, 1000);
    const refreshClick = (event) => {
        setRefreshLeaderBoard(!refreshLeaderBoard);
        setDiff(0);
    }
    const handleClick = () => {
    };

    const download = () => {
        const url = question.file;
        window.open(url, '_blank');
    };
    function useInterval(callback, delay) {
        const savedCallback = useRef();

        // Remember the latest function.
        useEffect(() => {
            savedCallback.current = callback;
        }, [callback]);

        // Set up the interval.
        useEffect(() => {
            function tick() {
                savedCallback.current();
            }
            if (delay !== null) {
                let id = setInterval(tick, delay);
                return () => clearInterval(id);
            }
        }, [delay]);
    }
    const [name, setName] = React.useState("");
    const [question, setQuestion] = React.useState(false);
    const [challenges, setChallenges] = React.useState(false);
    const [answers, setAnswers] = React.useState(false);
    function getAnswers(c) {
        if (!c)
            c = challenges;
        Axios.post(Config.api + "ICTChallenge/GetAnswers", {
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setAnswers(result.data.data);
                for (var i = 0; i < c.questions.length; i++) {
                    c.questions[i].answered = false
                    result.data.data.find(function (answer, index) {
                        if (answer.question == c.questions[i]._id) {
                            c.questions[i].answered = true
                        }
                    });
                }
                setChallenges(c)
                if (c.questions.length > 0)
                    setQuestion(c.questions[0])
            }).catch((err) => {
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")
            })
    }
    useEffect(() => {
        Axios.post(Config.api + "ICTChallenge/GetChallenge", {
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setName(result.data.data.Team);
                getAnswers(result.data.data.Challenge);
            }).catch((err) => {
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.status && err.response.status === 404) {
                    swal("هم اکنون مسابقه ای در جریان نیست.");
                    props.history.push("/ICTChallenge");
                }
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")
            })
    }, [])



    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 80,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/bg12.jpg")} />
            <div className={classNames(classes.main, classes.minMainRaised)}>
                <div>
                    <div className={classes.container}>

                        <GridContainer justify="center" >
                            <GridItem xs={12} sm={12} md={12}>
                                <h3 className={classes.title + " " + classes.center + " " + classes.fullWidth}>
                                هشتمین دوره مسابقات چالش های فناوری اطلاعات کشور
                                <br />
                                ICT Challenge 8

                            </h3>
                                <div className={classes.description}>
                                    <p className={classes.center}> 
                                    برای اطلاعات بیشتر کتابچه راهنما را مطالعه فرمایید.
                                   <br />
                                    ابتدا لازم است حسابی در <a href='http://git.sharifcamp.ir' target='_blank'>http://git.sharifcamp.ir</a> ایجاد کنید.
                                    <br />
                                    <Button href='https://sharifcamp.ir/Files/ICT%20Challenge%20Guide%20Book.pdf' target='_blank' variant="contained" color="secondary" disableElevation>
                                           دانلود کتابچه راهنما
                                    </Button>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={3}>
                                <div className={classes.menu}>
                                    <div className={classes.rightBox}>
                                        <Card className={classes.root} variant="outlined">
                                            <CardContent>
                                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                    نام تـــیـــم
                                                   <Typography variant="h6" gutterBottom>
                                                        {name}
                                                    </Typography>
                                                </Typography>

                                            </CardContent>
                                            <CardActions>
                                            </CardActions>
                                        </Card>
                                    </div>
                                    <div className={classes.rightBox}>
                                        <Card className={classes.root} variant="outlined">
                                            <CardContent>
                                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                    سوالات
                                                </Typography>
                                                <List component="nav">
                                                    <List component="nav">
                                                        {challenges && challenges.questions.map((item, index) => {
                                                            return (
                                                                <ListItem
                                                                    button
                                                                    onClick={() => {
                                                                        setQuestion(item)
                                                                    }}
                                                                >
                                                                    <ListItemIcon>
                                                                        <NavigateBeforeOutlinedIcon />
                                                                    </ListItemIcon>
                                                                    <ListItemText className={classes.listitem} primary={item.title} />
                                                                    <ListItemIcon>
                                                                        <FiberNewIcon style={!item.answered ? {} : { display: 'none' }} />
                                                                    </ListItemIcon>
                                                                </ListItem>
                                                            )
                                                        })}
                                                    </List>
                                                </List>
                                            </CardContent>
                                            <CardActions>
                                            </CardActions>
                                        </Card>
                                    </div>
                                </div>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                                <br />
                                <div className={classes.menu}>
                                    <div className={classes.questionTile}>
                                        <Typography variant="h5" component="h1">
                                            {question ? question.title : ""}
                                        </Typography>
                                    </div>
                                    <div className={classes.chips}>
                                        <Chip
                                            size="small"
                                            icon={<ScoreOutlinedIcon />}
                                            onClick={handleClick}
                                            label={"امتیاز سوال: " + (question ? question.score : "")}
                                            variant="outlined"
                                        />
                                        <Chip
                                            size="small"
                                            icon={<HourglassEmptyOutlinedIcon />}
                                            onClick={handleClick}
                                            label={"کد پیگیری: " + (question ? question.trackId : "")}
                                            variant="outlined"
                                        />
                                        {(() => {
                                            if (question.file) {
                                                return (
                                                    <Chip
                                                        size="small"
                                                        color="primary"
                                                        onClick={download}
                                                        icon={<CloudDownloadOutlined />}
                                                        label={"دانلود پیوست سوال"}
                                                    />
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                                <Divider />
                                <div className={classes.questionText}>
                                    {ReactHtmlParser(question ? question.description : "")}
                                </div>
                                <SendAnswer buttonEnable={challenges.sendAnswer} questionId={question._id} onClickCallBack={getAnswers} />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                                <div className={classes.menu}>
                                    <div className={classes.rightBox}>

                                        <Card className={classes.root} variant="outlined">
                                            <CardContent>
                                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                    بــــــــــرترین ها
                                                </Typography>
                                                <LeaderBoard refresh={refreshLeaderBoard} teamName={name} />

                                            </CardContent>
                                            <CardActions>
                                                <div className={classes.actionButton}>
                                                    <div className={classes.center}>
                                                        <Button onClick={refreshClick} size="small" color="textSecondary">
                                                            <RefreshRoundedIcon />
                                                        </Button>
                                                        <br />
                                                        <Typography variant="caption" gutterBottom>
                                                            {(() => {
                                                                if (diff < 60) {
                                                                    return "همین الان"
                                                                }
                                                                if (diff < 3600)
                                                                    return "بیش از " + Math.floor(diff / 60) + " دقیقه پیش"
                                                                else {
                                                                    return "بیش از " + Math.floor(diff / 3600) + " ساعت پیش"
                                                                }
                                                            })()}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </CardActions>
                                        </Card>
                                    </div>
                                </div>
                            </GridItem>
                           {
                              <Ads />
                           }
                        </GridContainer>
                        <br />
                        <br />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
